import { render, staticRenderFns } from "./investments-table.vue?vue&type=template&id=15226dc1"
import script from "./investments-table.vue?vue&type=script&lang=js"
export * from "./investments-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15226dc1')) {
      api.createRecord('15226dc1', component.options)
    } else {
      api.reload('15226dc1', component.options)
    }
    module.hot.accept("./investments-table.vue?vue&type=template&id=15226dc1", function () {
      api.rerender('15226dc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/sales-comissions/investments-table.vue"
export default component.exports